import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import DashBoardRolePermissionGuardComponent from './component'
import Spinner from '@/common/components/Spinner'
import ErrorPage from '@/modules/error/components/ErrorPage'

const DashBoardPermissionGuard = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<ErrorBoundary fallbackRender={(props) => <ErrorPage {...props} />}>
				<DashBoardRolePermissionGuardComponent />
			</ErrorBoundary>
		</Suspense>
	)
}

export default DashBoardPermissionGuard
